// extracted by mini-css-extract-plugin
export var card = "ProductListingView-module--card--iffwF";
export var content = "ProductListingView-module--content--34IQw";
export var headline = "ProductListingView-module--headline--3CWSK";
export var button = "ProductListingView-module--button--3rEMX";
export var description = "ProductListingView-module--description--2EiXj";
export var spinAround = "ProductListingView-module--spinAround--1Jk8T";